import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    customHeadersTitle: string;
    customHeadersDescription: string;
    commentAttachmentsTitle: string;
    commentAttachmentsDescription: string;
    reelLayoutTitle: string;
    reelLayoutDescription: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Title for custom-branded shares feature */
            customHeadersTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "config.customHeadersTitle?c=2mk60natasbc7", defaultMessage: "Custom-Branded Shares" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description explaining custom-branded shares feature */
            customHeadersDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "config.customHeadersDescription?c=1gxbhzav8q0ow", defaultMessage: "Personalize your Share with a custom background image, logo, and description, and choose to display or hide creator info." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Title for comment attachments feature */
            commentAttachmentsTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "config.commentAttachmentsTitle?c=3saamj7e9jb2b", defaultMessage: "Comment Attachments" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description explaining comment attachments feature */
            commentAttachmentsDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "config.commentAttachmentsDescription?c=16cnb476wifh8", defaultMessage: "Add more context to your comments by attaching images, videos, and documents." }));
                },
                enumerable: true,
                configurable: true
            },
            /** Title for reel layout feature */
            reelLayoutTitle: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "config.reelLayoutTitle?c=g61avs2i6b9o", defaultMessage: "Reel Layout" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Description explaining reel layout feature */
            reelLayoutDescription: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "config.reelLayoutDescription?c=iit5guqf7f2h", defaultMessage: "Showcase your content in its best light with a Reel layout that puts assets front and center above a seamless navigational carousel." }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
